import AbstractRequestTask from "../AbstractRequestTask";
import Device from "../../../devices/device";
import Launcher from '../../apa/Launcher';
import settings from "../../../devices/all/settings";
class authdeviceTask extends AbstractRequestTask {

    constructor(params) {
      super();
      this.extraparams=params;
    }

    getHeaders() {
        return {};
    }

    getUrl() {

      if(settings.fake_url_mockoon) {
        return `${settings.fake_url_mockoon}/services/user/authdevice`;
      }
      else {
        const http = "https://";
        const url = Launcher.get("akamai_mfwk");
        return `${http}${url}/services/user/authdevice`;
      }    
    }

    getParams() {
      const params = super.getParams();
      this.extraparams.serial_id =Device.getDevice().getConfig().serial_id;

      return Object.assign({}, params, this.extraparams);
    }

    success(data, b) {
        this.resolve(data);
    }

    getShowModal() {
      return false;
    }

    getRetriesNumber(){
      return 0;
    }
}

export default authdeviceTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/authdeviceTask.js